// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1b8Bk","approved":"Status_approved__2ysWj","rejected":"Status_rejected__2l8s9","expired":"Status_expired__1AzAP","label":"Status_label__3w_bW"};